export default "__VITE_ASSET__DCu2lScm__"